import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Button from "./Button.tsx";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

interface ErrorModalProps {
  open: boolean;
  onClose: () => void;
  message?: string;
  buttonText?: string;
}

const ErrorModal: React.FC<ErrorModalProps> = ({
  open,
  onClose,
  message = "Issue with Uploaded Dataset - Error Encountered!",
  buttonText = "Close"
}) => {
  function setSelectedDatasource(arg0: string): void {
    throw new Error("Function not implemented.");
  }

  return (
    <>
      <Modal
        backdrop="static"
        centered={true}
        toggle={onClose}
        isOpen={open}
        className="rv-modal"
      >
        <ModalHeader className="w-100 justify-content-center p-13 position-relative rv-breadcrumb-border ">
          Error
          <button
            type="button"
            className="close-button-currency position-absolute top-0 end-0 mt-1 me-3 border-0 bg-transparent fs-3"
            onClick={onClose}
          >
            &times;
          </button>
        </ModalHeader>
        <ModalBody className="fs-5 fw-bold text-center d-block">
          {message}

        </ModalBody>
        <ModalFooter className="d-flex justify-content-center align-items-center p-4">
          <div className="d-flex flex-row gap-3">
            <Button
              className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
              onClick={onClose}
            >
              <i className="ri-check-line ri-xl label-icon align-middle me-1"></i>
              {/* <RiPlayLargeLine size={16} /> */}
              <span className="ps-3 px-2 ms-2 me-1 modal-btn">{buttonText}</span>
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ErrorModal;
